import React, { Component } from 'react';
import PropTypes from 'prop-types';
import shallowEqual from 'shallowequal';
import deepEqual from 'deep-equal';

export default class NodeHeader extends Component {
  constructor(props) {
    super(props);
  }
  shouldComponentUpdate(nextProps) {
    const props = this.props;
    const nextPropKeys = Object.keys(nextProps);
    for (let i = 0; i < nextPropKeys.length; i += 1) {
      const key = nextPropKeys[i];
      if (key !== 'animations') {
        const isEqual = shallowEqual(props[key], nextProps[key]);
        if (!isEqual) {
          return true;
        }
      }
    }
    return !deepEqual(props.animations, nextProps.animations, { strict: true });
  }
  render() {
    const { style, decorators, tabSelected, treeData } = this.props;
    let terminal;
    if (tabSelected !== 'geographies') {
      terminal = this.props.node.rectype === 'Q';
    } else {
      terminal = this.props.node.type === 'L';
    }

    const active = this.props.node.active;
    const container = [style.link, active ? style.activeLink : null];
    const headerStyles = Object.assign({ container }, this.props.style);
    return (
      <decorators.Container
        style={headerStyles}
        decorators={decorators}
        terminal={terminal}
        onMouseDown={this.props.onMouseDown}
        animations={this.props.animations}
        node={this.props.node}
        tabSelected={tabSelected}
        treeData={treeData}
      />
    );
  }
}

NodeHeader.propTypes = {
  style: PropTypes.shape({}).isRequired,
  decorators: PropTypes.shape({}).isRequired,
  animations: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
    .isRequired,
  node: PropTypes.shape({
    active: PropTypes.bool,
    rectype: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  onMouseDown: PropTypes.func,
  tabSelected: PropTypes.string,
  treeData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
